import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect, Route, Switch, useParams, useRouteMatch } from 'react-router-dom';
import { getMemory, resetEditor } from './actions';
import { BiographyResultScreen } from './screens/BiographyResultScreen';
import { BlockIndexScreen } from './screens/BlockIndexScreen';
import { BlockQuestionScreen } from './screens/BlockQuestionScreen';
import { GeneratingScreen } from './screens/GeneratingScreen';
import { PresentationScreen } from './screens/PresentationScreen';

export const BiographicalEditorRoutes = () => {
  const dispatch = useDispatch();
  const { path } = useRouteMatch();
  const { idLine } = useParams();
  const biographicalMemoryMyUuid = useSelector((state) => state.line.active?.biographicalMemoryMyUuid);

  // Reset and load memory whenever the line changes
  useEffect(() => {
    if (idLine) {
      dispatch(resetEditor());
      dispatch(getMemory(idLine, biographicalMemoryMyUuid));
    }
  }, [idLine]);

  return (
    <Switch>
      <Route path={`${path}`} component={PresentationScreen} exact />
      <Route path={`${path}/blocks`} component={BlockIndexScreen} exact />
      <Route path={`${path}/blocks/:blockKey`} component={BlockQuestionScreen} exact />
      <Route path={`${path}/generating`} component={GeneratingScreen} exact />
      <Route path={`${path}/result`} component={BiographyResultScreen} exact />
      <Redirect to={`${path}`} />
    </Switch>
  );
};

export default BiographicalEditorRoutes;
